import { render, staticRenderFns } from "./EmployeeSalarySettingDelete.vue?vue&type=template&id=3526773c&scoped=true&"
import script from "./EmployeeSalarySettingDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalarySettingDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3526773c",
  null
  
)

export default component.exports